export default __webpack_public_path__ + "static/media/66.aaa64008.jpeg";